import { graphql } from '@/gql/codegen/gql';
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

export const OVERWRITE_GOAL_MUTATION = graphql(/* GraphQL */ `
  mutation EmbaOverwriteGoal($input: OverwriteGoalMutationInput!) {
    embaOverwriteGoal(input: $input) {
      embaUserGoalDialogResult {
        id
        goal
      }
    }
  }
`);

export const useOverwriteGoalMutation = (
  userAttendanceSlug: string,
  lessonSlug: string,
) => {
  const [
    overwriteGoalMutation,
    {
      error: overwriteGoalMutationError,
      loading: overwriteGoalMutationLoading,
    },
  ] = useMutation(OVERWRITE_GOAL_MUTATION);

  const overwriteGoal = useCallback(
    async (overwrittenUserGoal: string): Promise<void> => {
      await overwriteGoalMutation({
        variables: {
          input: {
            embaUserAttendanceSlug: userAttendanceSlug,
            embaCourseLessonSlug: lessonSlug,
            overwrittenUserGoal,
          },
        },
      });
    },
    [userAttendanceSlug, lessonSlug, overwriteGoalMutation],
  );

  return {
    overwriteGoal,
    overwriteGoalMutationError,
    overwriteGoalMutationLoading,
  };
};
